import styled from "styled-components";

const Box = styled.div`
  width: 100vw;
  height: 100vh;
  padding: 20px;
  background:#38B6FF;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;

`;

const Loading = () => {
  return (
    <Box>
      <h2>宇宙波波官方網站起飛中...</h2>
    </Box>
  );
};

export default Loading;
